// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import auditFindingEntity from './entities/audit-finding.json';
import auditFindingMenu from '../pages/audit-finding/menu.json';
import auditFindingFullForm from '../pages/audit-finding/forms/full.json';
import auditFindingContextForm from '../pages/audit-finding/forms/context.json';
import auditFindingMiniForm from '../pages/audit-finding/forms/mini.json';
import auditFindingLookupForm from '../pages/audit-finding/forms/lookup.json';
import auditFindingTableView from '../pages/audit-finding/views/table.json';
import auditFindingCardsView from '../pages/audit-finding/views/cards.json';
import auditFindingDashboardView from '../pages/audit-finding/views/dashboard.json';

/** Тип запису «Висновок аудиту» зі сторінками пакета: меню, форми та подання з pages/audit-finding/. */
export const auditFindingDefinition: IRecordTypeDefinition = {
  ...auditFindingEntity,
  views: assembleViewSet({
      table: auditFindingTableView,
      cards: auditFindingCardsView,
      dashboard: auditFindingDashboardView,
  }),
  form: auditFindingFullForm,
  forms: { full: auditFindingFullForm, context: auditFindingContextForm, mini: auditFindingMiniForm, lookup: auditFindingLookupForm },
  menu: auditFindingMenu,
} as IRecordTypeDefinition;
